import { TUrlParams } from '@/types';
import { TDictionary } from '@/types';

class UrlService {
  static parseParamsFromUrl(query: TDictionary<string>): TUrlParams {
    const urlParams = [] as TUrlParams;

    try {
      for (const name in query) {
        if (Array.isArray(query[name])) {
          for (const item of query[name]) {
            urlParams.push({
              name,
              value: item,
            });
          }
        } else {
          urlParams.push({
            name,
            value: query[name],
          });
        }
      }
    } catch (err) {
      console.error('parseParamsFromUrl: ', err);
    }

    return urlParams;
  }
}

export default UrlService;
